import React from "react";
import { SimpleGrid } from "@chakra-ui/react";
import { Cake, Users } from "lucide-react";
import type { MarriageProfileDto } from "src/types/Profile";
import type { PersonalInfo } from "src/types/matrimonyProfileDetails";
import InfoCard from "../InfoCard";
import KeyValueRow from "../KeyValueRow";
import EditButton from "../EditButton";
import { FIELD_LABELS } from "src/utils/matrimonyFieldLabels";
import { RELIGION_OPTIONS, getOptionLabel } from "src/utils/matrimonyOptions";

type PersonalSectionProps = {
  personal: PersonalInfo;
  dto: MarriageProfileDto;
  isOwnProfile: boolean;
  onEdit: () => void;
};

const PersonalSection: React.FC<PersonalSectionProps> = ({ personal, dto, isOwnProfile, onEdit }) => (
  <InfoCard
    title="Personal Information"
    icon={<Users size={18} />}
    rightSlot={isOwnProfile ? <EditButton onClick={onEdit} /> : null}
  >
    <SimpleGrid columns={{ base: 1, md: 2 }} spacing={{ base: 3, md: 4 }}>
      <KeyValueRow label={FIELD_LABELS.DATE_OF_BIRTH} value={personal.dob} icon={<Cake size={20} />} />
      <KeyValueRow label={FIELD_LABELS.MARITAL_STATUS} value={personal.maritalStatus} icon={<Users size={20} />} />
      <KeyValueRow label={FIELD_LABELS.GENDER} value={personal.gender} icon={<Users size={20} />} />
      <KeyValueRow label={FIELD_LABELS.RELIGION} value={getOptionLabel(RELIGION_OPTIONS, dto.religion)} icon={<Users size={20} />} />
      <KeyValueRow label={FIELD_LABELS.CASTE_DETAILS} value={dto.casteDetails || ""} icon={<Users size={20} />} />
    </SimpleGrid>
  </InfoCard>
);

export default PersonalSection;
